<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Facturación</f7-nav-title>
    </f7-navbar>
    <div class="sello-datos-bar"><sello-datos estado="vivo" /></div>
    <f7-block-header style="font-size: 13px; color: #666; margin-top: 8px">
      Facturación y cobro real de la empresa
    </f7-block-header>
    <div class="facturacion-grid">
      <f7-link href="/dashboard/facturacion/ejercicios/" class="facturacion-card active" style="border-bottom: 4px solid #BA7517">
        <div class="card-icon" style="background: #FAEEDA">
          <f7-icon f7="chart_bar_alt_fill" style="color: #BA7517; font-size: 24px"></f7-icon>
        </div>
        <!-- #248 · la tarjeta dice lo MISMO que la cabecera de la pantalla que abre, letra por
             letra. El nombre largo es justo lo que pidió dirección: esta es la entrada por la que
             se busca el cobro por ejercicios, y «Por ejercicios» no lo nombraba. -->
        <p class="card-title">FACTURACIÓN Y COBRO POR EJERCICIOS</p>
        <p class="card-subtitle">Comparativa 2020-{{ new Date().getFullYear() }}</p>
      </f7-link>
      <!-- La Tarjeta A · Control diario, que trae la F2 (#170). Deja de estar «próximamente»: la
           tarjeta la crea esta fase dentro de la pestaña que ya existía. -->
      <f7-link href="/dashboard/facturacion/control-diario/" class="facturacion-card active" style="border-bottom: 4px solid #534AB7">
        <div class="card-icon" style="background: #EEEDFE">
          <f7-icon f7="calendar_today" style="color: #534AB7; font-size: 24px"></f7-icon>
        </div>
        <!-- #248 · mismo texto que la cabecera de la pantalla que abre. -->
        <p class="card-title">CONTROL DIARIO FACTURACIÓN</p>
        <p class="card-subtitle">Objetivos y datos del día</p>
      </f7-link>
      <!-- #905 · OEE › Autorizaciones. Se dibuja si y solo si la ruta está en el menú efectivo
           (CLAUDE.md §9): un botón que lleva a un 403 es peor que no tener botón. -->
      <f7-link v-if="puedeAutorizaciones" :href="rutaAutorizaciones" class="facturacion-card active" style="border-bottom: 4px solid #C8862A">
        <div class="card-icon" style="background: #FFF6E5">
          <f7-icon f7="checkmark_shield" style="color: #C8862A; font-size: 24px"></f7-icon>
        </div>
        <p class="card-title">OEE · AUTORIZACIONES</p>
        <p class="card-subtitle">Lo que retrasa o anula una factura</p>
      </f7-link>
    </div>
  </f7-page>
</template>
<style scoped>
.facturacion-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 16px;
  padding: 16px;
}
.facturacion-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  padding: 20px;
  text-align: center;
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.facturacion-card.active {
  cursor: pointer;
}
.facturacion-card.active:active {
  transform: scale(0.97);
}
.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}
.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1a2744;
  margin: 0;
}
.card-subtitle {
  font-size: 11px;
  margin: 2px 0 0;
  color: #7c8db0;
}

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; }
</style>
<script>
import SelloDatos from '../../components/SelloDatos.vue';
import { puedeAbrirAutorizaciones, RUTA_AUTORIZACIONES } from './permisos-autorizaciones.js';
export default {
  components: { SelloDatos },
  data: function() {
    return {
      puedeAutorizaciones: puedeAbrirAutorizaciones(),
      rutaAutorizaciones: RUTA_AUTORIZACIONES
    };
  }
};
</script>
